import { message } from '@flowus/common/components/message';
import { setScreenLock } from 'src/services/screen-lock';
import { SettingMenuType } from 'src/views/main/setting-modal/type';
import { openSettingModal } from 'src/views/main/setting-modal/use-open-setting-modal';
import { getCurrentUser } from '../user/use-current-user';

export const lockScreen = () => {
  if (!getCurrentUser().setting.pin) {
    message.warning({
      content: (
        <div className="space-x-2">
          <span>{'请先设置 PIN 码'}</span>
          <span
            className="animate-click text-active_color"
            onClick={() => openSettingModal({ defaultMenuType: SettingMenuType.account })}
          >
            {'前往设置'}
          </span>
        </div>
      ),
    });
    return;
  }
  setScreenLock({ enable: true });
};
